export default __webpack_public_path__ + "0ed044d25f60ec54f027d061862f90e2.jpg";